import { getRepeatProductObject } from './get-repeat-product-object';

const completeStateSearch = (state) => ({
  ...state,
  cards: [],
  sameItemList: getRepeatProductObject(state.results),
});

export { completeStateSearch };
